import React from "react";
import OldResultsIndex from "../../components/results/OldResultsIndex";

const OldResultsPage = () => {
  return <OldResultsIndex />;
};

export default OldResultsPage;
